import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { CatchPraise } from "@components/catchPraise";
import { CustomFlex, CustomText } from "./roomDescription.style";
import { type RoomDescriptionProps } from "./roomDescription.type";

export const RoomDescription = ({ roomDetailInfo }: RoomDescriptionProps) => {
    const { name, personOfCapacity, structure, imgGroup, amenities } = roomDetailInfo;
    const { max, min } = personOfCapacity;
    const catchPraise = {
        main: {
            firstLine: name,
        },
        sub: {
            firstLine: `기준 ${min}인 / 최대 ${max}인`,
            secondLine: structure,
        },
    };

    const amenityFacilityGroup = amenities[0];
    const amenityIconGroup = amenities[1];

    const { isMobile } = MEDIA();

    return (
        <Flex mt={isMobile ? "568px" : "600px"} flexDir={isMobile ? "column" : "row"} p={isMobile ? "0 20px" : "0"}>
            <Box
                w="100%"
                h={isMobile ? "320px" : "480px"}
                borderRadius="24px"
                flexShrink={isMobile ? 0 : 1}
                background={`url(${imgGroup.sub}) no-repeat center/cover`}
            ></Box>
            <Flex
                w="100%"
                flexDir="column"
                justifyContent="space-between"
                p={isMobile ? "32px 0 0" : "40px 64px"}
                boxSizing="border-box"
                rowGap={isMobile ? "32px" : "auto"}
            >
                <CatchPraise annotation="Rooms" catchPraise={catchPraise} isDetail />
                <Flex ml={isMobile ? "0" : "32px"} flexDir="column" rowGap="24px">
                    <CustomFlex borderRadius="8px" flexDir="column">
                        <CustomText>AMENITIES & SERVICE</CustomText>
                        <Center p="8px" justifyContent="space-between">
                            {amenityIconGroup.map((icon) => {
                                return (
                                    <Box
                                        key={icon.iconUrl}
                                        w="64px"
                                        h="64px"
                                        background={`url(${icon.iconUrl}) no-repeat center/cover`}
                                    ></Box>
                                );
                            })}
                        </Center>
                    </CustomFlex>
                    <Flex flexWrap="wrap">
                        <Text fontWeight={700} mr="4px">
                            구비시설 :
                        </Text>
                        {amenityFacilityGroup.map((facility, idx) => {
                            return (
                                <Text flexShrink={0} key={facility.name} _notLast={{ marginRight: "4px" }}>
                                    {facility.name}
                                    {idx !== amenityFacilityGroup.length - 1 && ","}
                                </Text>
                            );
                        })}
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};
